export default "__VITE_ASSET__9495a27f__"